type ObserverCallback = (target: Element) => void;

class SwiperIntersectionObserver {
  private observer: IntersectionObserver;

  private targets: Map<Element, ObserverCallback> = new Map<Element, ObserverCallback>();

  private callbackTimeouts: Map<string, number> = new Map<string, number>();

  private scrollTimeout?: number;

  private isScrolling: boolean = false;

  constructor() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: null,
      rootMargin: '0%',
      threshold: 0.0,
    });
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  private handleScroll() {
    this.isScrolling = true;
    clearTimeout(this.scrollTimeout);

    this.scrollTimeout = window.setTimeout(() => {
      this.isScrolling = false;
    }, 500);
  }

  observe(target: Element, callback: ObserverCallback) {
    this.targets.set(target, callback);
    this.observer.observe(target);
  }

  unobserve(target: Element) {
    this.targets.delete(target);
    this.callbackTimeouts.delete(target.id);
    this.observer.unobserve(target);
  }

  private handleIntersect(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.scheduleCallback(entry.target);
      } else if (this.callbackTimeouts.has(entry.target.id)) {
        window.clearTimeout(this.callbackTimeouts.get(entry.target.id));
      }
    });
  }

  private scheduleCallback(target: Element) {
    const checkScrolling = () => {
      if (!this.isScrolling) {
        const callback = this.targets.get(target);
        this.unobserve(target);
        if (callback) {
          callback(target);
        }
      } else {
        const t = window.setTimeout(checkScrolling, 250);
        this.callbackTimeouts.set(target.id, t);
      }
    };

    checkScrolling();
  }
}

export const swiperIntersectionObserver = new SwiperIntersectionObserver();
